<template>
  <div class="notice_list">
    <div class="tit">
      <span>园区通告</span>
    </div>
    <div class="body_content" v-if="isCertified === 1">
      <div class="notice_type">
        <div
          :class="{type_item:true,active:type_index===index}"
          v-for="(item, index) in type_list"
          :key="index"
          @click="changeType(index,item.code)"
        >{{item.name}}</div>
      </div>
      <div class="n_list" v-if="notice_list.length">
        <router-link
          tag="div"
          :to="'/personal_center/park_user/park_notice/notice_detail?id='+item.id"
          class="list_item"
          v-for="(item, index) in notice_list"
          :key="index"
        >
          <div class="notice_info">
            <div class="notice_img">
              <img :src="item.coverPath" v-if="item.coverPath" alt />
              <img v-else src="@/assets/img/common/noimg.png" alt />
            </div>
            <div class="notice_title">{{item.name}}</div>
          </div>
          <div class="notice_date">{{item.create_date}}</div>
        </router-link>
      </div>
      <div v-else class="no_data">暂无通告</div>
      <myPage :layerpageinfo="layerpageinfo"></myPage>
    </div>
    <div class="body_content" v-else>
      <div class="btns">
        <div class="btn_left">
          <el-button type="primary" @click="toEmployeeCertify">认证为员工</el-button>
          <el-button type="primary" @click="toEnterpriseCertify">认证为企业</el-button>
        </div>
      </div>
      <!-- <myTable :tableObj="tableObj" @btnClick="btnClick" @changePageNo="getList"></myTable> -->
    </div>
  </div>
</template>
<script>
import myPage from "@/components/myPage/myPage.vue";
export default {
  components: {
    myPage
  },
  data() {
    return {
      type_list: [], //通告类型列表
      notice_list: [], //通告列表
      type_index: 0, //类型index
      layerpageinfo: {
        total: 0,
        pageNo: 0,
        pageSize: 5
      },
      isCertified: 1
    };
  },
  computed: {
    info() {
      return this.$store.state.info;
    },
    parkInfo() {
      return this.$store.state.parkInfo;
    }
  },
  created() {
    if (this.info && this.parkInfo) {
      this.certified();
    } else {
      this.needInfo("certified");
    }
  },

  methods: {
    needInfo(fn) {
      let watchAch = this.$watch("info", (val, oldVal) => {
        if (val) {
          console.log(this.info);

          this[fn]();
          watchAch(); //取消监听
        }
      });
    },
    /* 获取个人信息 */
    certified() {
      if (this.info.role === "UserRoleOrdinary") {
        this.isCertified = 2;
      } else {
        this.isCertified = 1;
        this.getNoticeType(); //获取通告类型
      }
    },
    //根据类型查询通告列表
    getNoticeList(typeCode) {
      this.api
        .getNews({
          type: "ActiveTypeParkNotice",
          class_one: typeCode,
          incubator: this.parkInfo.id,
          sort: "SortDefault"
        })
        .then(res => {
          console.log(res);
          if (res.error.err_code !== 0) return;
          let list = res.obj.list;
          this.notice_list = list.length ? list : [];
          this.layerpageinfo.total = res.obj.totalSize;
        });
    },
    //查询通告类型
    getNoticeType() {
      this.api
        .getDictionaries({ typeCode: "ActiveTypeParkNotice" })
        .then(res => {
          console.log(res);
          if (res.error.err_code !== 0) return;
          let list = res.obj.list;
          this.type_list = list.length ? list : [];
          //第一次进页面请求第一种类型的通告
          this.getNoticeList(list.length ? list[0].code : "");
        });
    },
    //点击类型查询通告
    changeType(index, code) {
      this.type_index = index;
      this.getNoticeList(code);
    },
    //跳转员工认证
    toEmployeeCertify() {
      this.$router.push({ name: "employee_certification" });
    },
    //跳转企业认证
    toEnterpriseCertify() {
      this.$router.push({ name: "enterprise_certification" });
    }
  }
};
</script>
<style lang="scss" scoped>
.notice_list {
  .notice_type {
    display: flex;
    // margin-bottom: 30px;
    height: 64px;
    .type_item {
      width: 90px;
      height: 34px;
      box-sizing: border-box;
      border: 1px solid rgba(220, 223, 230, 1);
      color: rgba(75, 80, 98, 1);
      font-size: 14px;
      line-height: 34px;
      border-radius: 2px;
      text-align: center;
      margin-right: 14px;
      cursor: pointer;
    }
    .active {
      color: rgba(255, 115, 60, 1);
      border: 1px solid rgba(255, 115, 60, 1);
    }
  }
  .n_list {
    .list_item:first-child {
      padding-top: 0;
    }
    .list_item {
      display: flex;
      width: 100%;
      cursor: pointer;
      justify-content: space-between;
      padding: 20px 0;
      border-bottom: 1px solid rgba(236, 240, 245, 1);
      .notice_info {
        display: flex;
        .notice_img {
          width: 90px;
          height: 67px;
          margin-right: 14px;
          // overflow: hidden;
          img {
            width: 90px;
            height: 67px;
          }
        }
        .notice_title {
          font-size: 14px;
          color: rgba(75, 80, 98, 1);
          max-width: 490px;
          line-height: 34px;
        }
      }
      .notice_date {
        line-height: 34px;
        font-size: 14px;
        color: rgba(158, 162, 179, 1);
      }
    }
  }
  .no_data {
    text-align: center;
    line-height: 50px;
  }
}
</style>